export default __webpack_public_path__ + "static/media/fasting@2x.a0210fbe.jpg";